import React, { useEffect, useRef, useState } from "react";
import {
  CallOutlined,
  HowToRegOutlined,
} from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import gsap from "gsap";
import { ModalContact } from "./ModalContact";


const styles = {
  container: {
    position: "fixed",
    display: "flex",
    zIndex: 9999,
    gap: 15,
  },
  desktopContainer: {
    right: 20,
    top: "40%",
    flexDirection: "column",
  },
  mobileContainer: {
    bottom: 20,
    left: "50%",
    transform: "translateX(-50%)",
    flexDirection: "row",
  },
  button: {
    width: 56,
    height: 56,
    borderRadius: 12,
    border: "2px solid rgba(255,255,255,0.2)",
    backgroundColor: "rgba(0,0,0,0.4)",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: "0 0 8px rgba(0,0,0,0.5)",
    transition: "all 0.3s ease",
    textDecoration: "none",
    backdropFilter: "blur(6px)",
  },
  buttonHover: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    boxShadow: "0 0 15px #fff",
    borderColor: "#ccc",
    color: "#fff",
  },
};

const FixedButtons = () => {
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
 
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Animate fixed buttons
  useEffect(() => {
    const buttons = containerRef.current.children;
    gsap.fromTo(
      buttons,
      { opacity: 0, y: 20, scale: 0.9 },
      { opacity: 1, y: 0, scale: 1, duration: 0.6, stagger: 0.15, ease: "power3.out" }
    );
    gsap.to(buttons, {
      scale: 1.05,
      repeat: -1,
      yoyo: true,
      duration: 1.2,
      ease: "power1.inOut",
      stagger: 0.2,
    });
    return () => gsap.killTweensOf(buttons);
  }, [isMobile]);

  

  const handleMouseEnter = (e) => Object.assign(e.currentTarget.style, styles.buttonHover);
  const handleMouseLeave = (e) => Object.assign(e.currentTarget.style, styles.button);


  const [showModal, setShowModal] = useState(false); // state للتحكم بالمودال

  return (
    <div
      ref={containerRef}
      style={{
        ...styles.container,
        ...(isMobile ? styles.mobileContainer : styles.desktopContainer),
      }}
    >
      {/* <Modal open={open} onClose={handleClose}>
        <Box
          ref={modalRef}
          sx={{
            backgroundColor: "white",
            padding: 3,
            borderRadius: 2,
            width: 400,
            mx: "auto",
            mt: "10%",
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" mb={2}>
            Book Your Appointment
          </Typography>

          <TextField
            label="Name"
            fullWidth
            margin="normal"
            value={formData.name}
            onChange={handleChange("name")}
          />

          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={formData.email}
            onChange={handleChange("email")}
          />

          <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
            <TextField
              select
              label="Country"
              value={formData.country}
              onChange={handleChange("country")}
              sx={{ width: "40%" }}
            >
              {countries.map((c) => (
                <MenuItem key={c.code} value={c.code}>
                  {c.name} ({c.code})
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Phone"
              type="tel"
              sx={{ width: "60%" }}
              value={formData.phone}
              onChange={handleChange("phone")}
            />
          </Box>

          <Button
            variant="contained"
            color="success"
            fullWidth
            sx={{ mt: 3 }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Modal> */}

      {/* Buttons */}
      <a
        href="tel:+971523844444"
        style={styles.button}
        title="اتصال"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <CallOutlined fontSize="large" />
      </a>

      <a
        href="https://wa.me/971523844444"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.button}
        title="واتساب"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <WhatsAppIcon fontSize="large" />
      </a>

      <a
        href="#contact"
        style={styles.button}
        title="تواصل / تسجيل"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
       onClick={(e) => {
          e.preventDefault();
          setShowModal(true); // فتح المودال
        }}
      >
      
        <HowToRegOutlined fontSize="large" />
      </a>
       {/* هنا نضع ModalContact ونعطيه التحكم بالفتح والغلق */}
      <ModalContact open={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default FixedButtons;
